/* tslint:disable */
/* eslint-disable */
/**
 * users
 * users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserGroup } from './UserGroup';
import {
    UserGroupFromJSON,
    UserGroupFromJSONTyped,
    UserGroupToJSON,
    UserGroupToJSONTyped,
} from './UserGroup';

/**
 * 
 * @export
 * @interface FindAllUserGroups200Response
 */
export interface FindAllUserGroups200Response {
    /**
     * 
     */
    data?: Array<UserGroup>;
}

/**
 * Check if a given object implements the FindAllUserGroups200Response interface.
 */
export function instanceOfFindAllUserGroups200Response(value: object): value is FindAllUserGroups200Response {
    return true;
}

export function FindAllUserGroups200ResponseFromJSON(json: any): FindAllUserGroups200Response {
    return FindAllUserGroups200ResponseFromJSONTyped(json, false);
}

export function FindAllUserGroups200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllUserGroups200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(UserGroupFromJSON)),
    };
}

export function FindAllUserGroups200ResponseToJSON(json: any): FindAllUserGroups200Response {
    return FindAllUserGroups200ResponseToJSONTyped(json, false);
}

export function FindAllUserGroups200ResponseToJSONTyped(value?: FindAllUserGroups200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(UserGroupToJSON)),
    };
}

